import React from 'react';
import { Box, Divider, Grid } from '@mui/material';

import { BatchAndBundleButtonBar } from './BatchAndBundleButtonBar';
import { BatchesAndBundlesSidebar } from './BatchesAndBundlesSidebar';
import { ComponentsDifferFromProjectError } from './ComponentsDifferFromProjectError';
import { ComponentsToBatchOrBundleGrid } from './ComponentsToBatchOrBundleGrid';
import { StackedTrussPreview } from './StackedTrussPreview';

const componentPreviewWidth = 400;
const componentPreviewHeight = 150;

export function BatchesAndBundles() {
  return (
    <Grid container spacing={1} sx={{ flexGrow: 1, height: 'inherit' }}>
      <Grid size={8}>
        <ComponentsToBatchOrBundleGrid />
      </Grid>
      <Grid size={4}>
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ mb: 1 }}>
            <StackedTrussPreview
              componentPreviewHeight={componentPreviewHeight}
              componentPreviewWidth={componentPreviewWidth}
            />
          </Box>
          <Box sx={{ mb: 1 }}>
            <BatchAndBundleButtonBar />
            <ComponentsDifferFromProjectError />
          </Box>
          <Divider sx={{ mb: 1 }} />
          <BatchesAndBundlesSidebar />
        </Box>
      </Grid>
    </Grid>
  );
}
